import { DrawingState, Mode, DrawingStateFns, ModeVehicleType } from "./ModeContext";
import { VehicleType, showVehicleType } from "./VehicleType";

export function createVehicleTypeMode( type: VehicleType ): ModeVehicleType {
    return { mode: Mode.VehicleType, type, setTo: undefined };
}

export const vehicleTypeModeFns: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        const mode   = drawMode as ModeVehicleType;
        const unsure = mode.unsure !== undefined;
        const color  = unsure ? "white" : "black";        
        return [
            //row 1
            { key: "q", label: "Car",     color: color, active: mode.type === VehicleType.Car     },
            { key: "w", label: "Suv",     color: color, active: mode.type === VehicleType.Suv     },
            { key: "e", label: "Van",     color: color, active: mode.type === VehicleType.Van     },
            { key: "r", label: "Pickup",  color: color, active: mode.type === VehicleType.Pickup  },
            null,

            //row 2
            { key: "a", label: "Freight", color: color, active: mode.type === VehicleType.Freight },
            { key: "s", label: "Bus",     color: color, active: mode.type === VehicleType.Bus     },
            null, 
            null, 
            null, 

            //row 3
            { key: "z", label: "Conv",    color: color, active: mode.type === VehicleType.Convertible },
            { key: "x", label: "Hatch",   color: color, active: mode.type === VehicleType.Hatchback   },
            null, 
            null,
            unsure ? null : { key: "b", label: "Unsure",  color: color,  active: mode.type === VehicleType.Unsure  },            
        ];
    },

    onKeyDown( drawMode, key, shift, ctx ) {
        const mode   = drawMode as ModeVehicleType;
        // const unsure = mode.unsure !== undefined;
        // if( !unsure ) {
        if( !shift && key === "q" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Car         } ); return true; }
        if( !shift && key === "w" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Suv         } ); return true; }
        if( !shift && key === "e" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Van         } ); return true; }
        if( !shift && key === "r" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Pickup      } ); return true; }
        if( !shift && key === "a" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Freight     } ); return true; }
        if( !shift && key === "s" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Bus         } ); return true; }
        if( !shift && key === "z" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Convertible } ); return true; }
        if( !shift && key === "x" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Hatchback   } ); return true; }
        if( !shift && key === "b" ) { ctx.setDrawMode( { ...mode, type: VehicleType.Unsure      } ); return true; }
        // }
        // if( shift  && key === "q" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Car     } ); return true; }
        // if( shift  && key === "w" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Suv     } ); return true; }
        // if( shift  && key === "e" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Van     } ); return true; }
        // if( shift  && key === "r" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Pickup  } ); return true; }
        // if( shift  && key === "a" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Freight } ); return true; }
        // if( shift  && key === "s" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Bus     } ); return true; }
        // if( shift  && key === "b" ) { ctx.setDrawMode( { ...mode, setTo: VehicleType.Unsure  } ); return true; }
        return false;
    },

    onDeckClick( drawMode, info, ctx ) {},
    onDeckHover( drawMode, info, ctx ) {},

    onAnnotationClick( drawMode, ann, ctx ) {
        const mode = drawMode as ModeVehicleType;
        // if( mode.type === VehicleType.Unsure ) {
        //     ctx.setDrawMode( { ...mode, unsure: ann } );
        //     return;
        // }
        ctx.handleEdit( { 
            ...ann, 
            attributes: { 
                ...ann.attributes,
                vehicleType: showVehicleType( mode.type ), 
                parts:       []
            } } );
    },

    filter( drawMode, ann ) {
        const mode = drawMode as ModeVehicleType;
        const typeCompare = showVehicleType( mode.type );
        return ann.attributes?.vehicleType === typeCompare;
    },

    getLineColor( drawMode, ann, ctx ) {
        const { obbAnnotationId: id, attributes: attrs } = ann;
        const done  = !( attrs.vehicleType === null );
        const alpha = id == ctx.hovObj?.obbAnnotationId ? 224 : 160;
        if( !done    ) { return [ 255, 255, 0, alpha ]; } //bright yellow
        if(  done    ) { return [   0, 255, 0, alpha ]; } //bright green
        return [255, 0, 0, 255];
    },

    getCursor( drawMode ) {
        return "grab";
    },

    getAnnotationLabel( drawMode, ann ) {
        const type = ann.attributes?.vehicleType ?? " ";
        return type[0].toUpperCase();
    }
};